
import mitt from 'mitt'

const eventMitt = mitt();

export default eventMitt;